import cn from 'classnames'
import React, {
  ComponentProps,
  forwardRef,
  ReactElement,
  ReactNode,
  Ref,
} from 'react'

import style from './IntegrationCard.style'

type IntegrationCardProps = {
  children: ReactNode
  className?: string
  interactive?: boolean
  onClick?: ComponentProps<'button'>['onClick']
  ariaLabel?: string
  disabled?: boolean
  'aria-busy'?: boolean
  'data-testid'?: string
}

const IntegrationCard = forwardRef<
  HTMLButtonElement | HTMLDivElement,
  IntegrationCardProps
>(function IntegrationCard(props, forwardedRef): ReactElement {
  const {
    children,
    className = '',
    interactive = false,
    onClick,
    ariaLabel,
    disabled = false,
    ...rest
  } = props
  const combinedClassName = cn('IntegrationCard', className, {
    interactive: interactive || onClick !== undefined,
    disabled,
  })

  if (onClick !== undefined) {
    return (
      <button
        ref={forwardedRef as Ref<HTMLButtonElement>}
        type="button"
        css={style}
        className={combinedClassName}
        aria-label={ariaLabel}
        disabled={disabled}
        onClick={onClick}
        {...rest}
      >
        {children}
      </button>
    )
  }

  return (
    <div
      ref={forwardedRef as Ref<HTMLDivElement>}
      css={style}
      className={combinedClassName}
      aria-disabled={disabled || undefined}
      {...rest}
    >
      {children}
    </div>
  )
})

export type { IntegrationCardProps }
export default IntegrationCard
